<template>
  <div class="row">
    <div class="col-12 mb-2">
      <div v-if="loading && loginType == 'ru-token'" class="ecp-loading">
        <ui-loading />
      </div>
      <ButtonItem v-else type="ru-token" @auth="handleAuth" />
    </div>
    <div class="col-12 mb-2">
      <div v-if="loading && loginType == 'crypto-pro'" class="ecp-loading">
        <ui-loading />
      </div>
      <ButtonItem v-else type="crypto-pro" @auth="handleAuth" />
    </div>
    <div class="col-12">
      <div v-if="loading && loginType == 'jakarta'" class="ecp-loading">
        <ui-loading />
      </div>
      <ButtonItem v-else type="jakarta" @auth="handleAuth" />
    </div>
  </div>
</template>

<script setup>
import ButtonItem from "./ButtonItem.vue";

const props = defineProps({
  loading: {
    type: Boolean,
  },
  loginType: {
    type: String,
  },
});

const emit = defineEmits(["auth"]);

const handleAuth = (type) => {
  emit("auth", type);
};
</script>